export enum LanguageType {
  EN,
  NL
}

export enum SolutionType {
  Approach,
  Oppurtunities
}
